import { evaluate } from 'mathjs';

export const conditionValidator = (_condition, _listValue, _listVariable, _translateTemp = false) =>
{

  try{

    let value = {
      valueLeft: "",
      valueRight: ""
    };


    switch (_condition.type)
    {
      case "if":


        ["valueLeft", "valueRight"].forEach(v =>
        {

          switch (_condition[v].type)
          {
            case "userVariable":


              value[v] = _listValue.find(value => value.component == _condition[v].component).data;


              if (!isNaN(value[v]))
              {
                value[v] = parseFloat(value[v])
              } else
              {
                value[v] = value[v].toUpperCase();
              }

              if (_condition[v].componentData.temperatureUnit && _translateTemp){
                value[v] = (value[v] - 32) * 5/9
              }


              break;

            case "globalVariable": 


              let variable = _listVariable.find(variable => variable._id == _condition[v].variable);

              

              switch (variable.variableTypeCode) {
                case "int":
                  value[v] = parseInt(variable.data);
                  break;
                case "number":
                  value[v] = Number(variable.data);
                  break;
                default:
                  value[v] = variable.data.toUpperCase();
                  break;
              }



              break;

            case "literal": {

              
              value[v] = _condition[v].data;

              //if (!isNaN(parseFloat(value[v]))){
              if (!isNaN(value[v])){
                value[v] = parseFloat(value[v])
              }else{
                value[v] = value[v].toUpperCase();
              }
                
              break;
            }
            case "formula": {

              let replacedFormula = _condition[v].data;

              // Regular expression to match strings within {} brackets
              let formulaRegex = /\{([^}]+)\}/g;

              // Array to store matched instances
              let variablesFound = [];

              // Match all instances of strings within {} brackets
              let variable;
              while ((variable = formulaRegex.exec(replacedFormula)) !== null)
              {
                variablesFound.push(variable[1]);
              }   

              variablesFound.forEach(v =>
              {

                const arrV = v.split(".");

                const stepTitle = arrV[0];
                const componentName = arrV[1];

                let indexVariable = _listValue.findIndex(lv => lv.stepTitle == stepTitle && lv.componentName == componentName);


                if (indexVariable > -1)
                {
                  replacedFormula = replacedFormula.split("{" + v + "}").join(_listValue[indexVariable].data);
                } else
                  throw new Error();

              });

              //Global Formula
              // Regular expression to match strings within [] brackets
              formulaRegex = /\[([^\]]+)\]/g;

              // Array to store matched instances
              variablesFound = [];

              while ((variable = formulaRegex.exec(replacedFormula)) !== null)
              {
                variablesFound.push(variable[1]);
              }  

              variablesFound.forEach(v =>
              {


                let indexVariable = _listVariable.findIndex(lv => lv.name == v);



                if (indexVariable > -1)
                {
                  replacedFormula = replacedFormula.split("[" + v + "]").join(_listVariable[indexVariable].data);
                } else
                  throw new Error();

              });

              console.log(replacedFormula);



              value[v] = evaluate(replacedFormula).toFixed(6);

              break;
            }
            default:
              break;
          }

        });

        //TEST
        //console.log("value", value, _condition.operator, operatorCompare(value.valueLeft, value.valueRight, _condition.operator));
        

        return operatorCompare(value.valueLeft, value.valueRight, _condition.operator);

      //IF SENSOR
      case "sensor":



        value.valueLeft = _listValue.find(value => value.component == _condition.valueLeft.component).data;

        if (_translateTemp){
          value.valueLeft = (value.valueLeft - 32) * 5 / 9;
        }

        value.valueRight = _listValue.find(value => value.component == _condition.valueRight.component).data;

        let currentSensor = _listVariable.find(variable => variable._id == _condition.sensor.variable);

        let currentRow = undefined;

        //Find the closest row in the sensor table
        currentSensor.data.row.forEach(r => {

          //Check diff of temperature between both
          if (!currentRow || Math.abs(currentRow.temperature - value.valueLeft) > Math.abs(r.temperature - value.valueLeft)  ) {
            currentRow = r;
          }


        });

        //If no row found, return false
        if (!currentRow) return false;


        //Check if resistance is between tolerance value
        if (value.valueRight >= currentRow.resistance * (1 - (currentSensor.data.tolerance / 100))
          && (value.valueRight <= currentRow.resistance * (1 + (currentSensor.data.tolerance / 100)))) return true;

        //Nothing found, return false
        return false;

      default:
        break;
    }


    return true;

  }catch(err){
    
    console.log(err);

    throw err;

  }
  


}


export const operatorCompare = (_valueLeft, _valueRight, _operator) => {

  try{


    switch (_operator) {
      case "eq":
        return _valueLeft == _valueRight;
      case "ne": 
        return _valueLeft != _valueRight;
      case "gt":
        return _valueLeft > _valueRight;
      case "gte":
        return _valueLeft >= _valueRight;
      case "lt":
        return _valueLeft < _valueRight;
      case "lte":
        return _valueLeft <= _valueRight;
      case "in":
        return _valueRight.includes(_valueLeft);
      case "notin":
        return !_valueRight.includes(_valueLeft);
      default:
        return false;
    }

  }catch(err){

    return err;

  }


}